import { useSelector, useStore } from 'react-redux';
import { updateDisplayActive } from './actions';
import { useHistory } from 'react-router-dom';

export default () => {
  const store = useStore();
  const history = useHistory();

  const displayActive = useSelector(
    store => store.tableAndToolbar.displayActive
  );
  const currentTenantId = useSelector(
    store => store.user.selectedTenant.tenantId
  );
  const currentBusinessContextId = useSelector(
    store => store.user.selectedBusinessContext.businessContextId
  );
  const supportedEventTypeOptions = useSelector(
    store => store.events?.supportedEventTypes.options
  );

  const onClickToggleArchive = action => {
    store.dispatch(updateDisplayActive(!displayActive));
    store.dispatch(action);
  };

  const onClickAdd = (action, urlPath) => {
    store.dispatch(action);
    history.push(urlPath);
  };

  const onClickEdit = (actions, urlPath) => {
    actions.map(action => store.dispatch(action));
    history.push(urlPath);
  };

  const formCopyTemplate = (template, urlPath) => {
    if (template.campaignOccurrenceType === "ON_EVENT" || template.campaignOccurrenceType === "SCHEDULED") {
      template.isTypeEditable = true;
      let currentEventType = supportedEventTypeOptions.filter(option => option.id === template.schemaIdentifier)[0];
      template.isLongTermStorage = currentEventType?.longTermStorage;
    }
    delete template.id;
    delete template.uuid;
    delete template.defaultTemplate;
    template._isCopy = true;
    template._isCopyTemplate = true;
    template.name = template.name + '-copy';
    template.active = true;
    template.schemaIdentifier = template.schemaIdentifier
      ? template.schemaIdentifier
      : template.productCategory
      ? `${template.productCategory}.${template.productName}.${template.eventTypeCategory}`
      : '';
    if ('/surveys/details' === urlPath) {
      template.locked = false;
      template.surveyQuestionResponseRules = [];
      if (currentBusinessContextId !== template.businessContextId) {
        let modifiedSurveyTheme = { ...template.surveyTheme };
        delete modifiedSurveyTheme.imageId;
        template.surveyTheme = { ...modifiedSurveyTheme };
      }
    }
    if (`/campaigns/settings` === urlPath) {
      template._hasSetTemplate = false;
      template._hasSetCampaignExclusionRules = false;
      if (template?.scheduleRule?.hasOwnProperty('recurrenceExpression')) {
        template.recurrence = true;
      }
    }
    return template;
  };

  const onClickCopy = (action, urlPath, id, templates) => {
    let template = Object.assign(
      {},
      templates.find(t => (t.id === id) || (t.uuid === id))
    );
    template = formCopyTemplate(template, urlPath);
    store.dispatch(action(template));
    history.push(urlPath);
  };

  const isTemplateReadOnly = (row, isLoading) => {
    return (
      !isLoading &&
      (row.id || row.uuid) &&
      (currentTenantId !== row.tenantId ||
        currentBusinessContextId !==
        (row.businessContextId || row.contextId))
    );
  };

  const isTenantDefaultTemplate = row => {
    return (
      (!row.defaultTemplate || row.tenantId === currentTenantId) &&
      (row.businessContextId || row.contextId) !== currentBusinessContextId
    );
  };

  return {
    onClickToggleArchive,
    onClickAdd,
    onClickEdit,
    onClickCopy,
    isTemplateReadOnly,
    isTenantDefaultTemplate
  };
};
